<script>
	import { Router, Route, Link } from 'svelte-routing';
	import Home from './routes/Home.svelte';
	import Pmsus from './routes/Materias/pmsus.svelte'
	import Ncs from './routes/Materias/ncs.svelte'
	import Hm from './routes/Materias/hm.svelte'

  </script>
  
  <Router>
	<nav>
	  <Link to="/">Início</Link>
	</nav>
  
	<Route path="/" component={Home} />
	<Route path="/pmsus/" component={Pmsus} />
	<Route path="/ncs/" component={Ncs} />
	<Route path="/hm/" component={Hm} />

  </Router>
  